/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Weiterbildungsmoeglichkeiten32Inputs */

const en__field_enum_tuda_weiterbildungsmoeglichkeiten32 = /** @type {(inputs: _Field_Enum_Tuda_Weiterbildungsmoeglichkeiten32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tips to find opertunities for more specialiced education`)
};

const de__field_enum_tuda_weiterbildungsmoeglichkeiten32 = /** @type {(inputs: _Field_Enum_Tuda_Weiterbildungsmoeglichkeiten32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipps zu Weiterbildungsmöglichkeiten`)
};

/**
* | output |
* | --- |
* | "tips to find opertunities for more specialiced education" |
*
* @param {_Field_Enum_Tuda_Weiterbildungsmoeglichkeiten32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_weiterbildungsmoeglichkeiten32 = /** @type {((inputs?: _Field_Enum_Tuda_Weiterbildungsmoeglichkeiten32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Weiterbildungsmoeglichkeiten32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_weiterbildungsmoeglichkeiten32(inputs)
	return de__field_enum_tuda_weiterbildungsmoeglichkeiten32(inputs)
});
export { _field_enum_tuda_weiterbildungsmoeglichkeiten32 as "_field_enum_TUDA_WEITERBILDUNGSMOEGLICHKEITEN" }